import React, { useState } from "react";
import SalesPersonFilter from "./SalesPersonFilter";
import SalesPersonReport from "./SalesPersonReport";
import DateRangeComponent from "../../../reuseableComponents/DateRangeComponent";
import DashDateRangeComponent from "../../../reuseableComponents/DashDateRangeComponent";
import useMultiSelect from "../../../hooks/useMultiSelect";

const MainSalesPerson = ({
  hide,
  setCSVData,
  setCSVHeader,
  setCSVFileName,
}) => {
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  // const [OrderSourceData, setOrderSourceData] = useState(null);
  // const [OrderTypeData, setOrderTypeData] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const handleDateRangeChange = (dateRange) => {
    setSelectedDateRange(dateRange);
  };

  const {
    selectedItems: selectedEmployeeList,
    allOptionSelected: allOptionSelectedEmployeeList,
    handleOptionClick: handleEmployeeListOptinClick,
  } = useMultiSelect(employeeList);

  return (
    <>
      <div className="q-order-main-page">
        <SalesPersonFilter
          setEmployeeList={setEmployeeList}
          employeeList={employeeList}
          selectedEmployeeList={selectedEmployeeList}
          allOptionSelectedEmployeeList={allOptionSelectedEmployeeList}
          handleEmployeeListOptinClick={handleEmployeeListOptinClick}
          hide={hide}
        />
      </div>

      <div className="q-order-main-page">
        <div className="box">
          {/* <DateRangeComponent onDateRangeChange={handleDateRangeChange} /> */}
          {hide ? (
            <DashDateRangeComponent onDateRangeChange={handleDateRangeChange} />
          ) : (
            <DateRangeComponent onDateRangeChange={handleDateRangeChange} />
          )}
        </div>
      </div>

      <SalesPersonReport
        selectedDateRange={selectedDateRange}
        // OrderSourceData={OrderSourceData}
        // OrderTypeData={OrderTypeData}
        SelectEmpListData={selectedEmployeeList}
        setCSVData={setCSVData}
        setCSVHeader={setCSVHeader}
        setCSVFileName={setCSVFileName}
        allOptionSelectedEmployeeList={allOptionSelectedEmployeeList}
      />
    </>
  );
};

export default MainSalesPerson;
